module.exports = __webpack_public_path__ + "img/drop_shadow.c742717d.png";